<template>
    <div>
        <vs-popup class="holamundo" title="Add New Slide" :active.sync="popupActive">
           
            <vx-input-group class="mb-3" v-if="channels.length !=0">
                <v-select
          id="country"
          v-model="slide.channel_id"
          :options="channels"
         placeholder="Select Channel"
          label="name"
        />
            </vx-input-group>
            <vx-input-group class="mb-3" v-if="schedule.length !=0">
                <v-select
          id="country"
          v-model="slide.program_id"
          :options="schedule"
         placeholder="Select Program"
          label="title"
        />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="slide.title" placeholder="Title" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="slide.decription" placeholder="Description" />
            </vx-input-group>

      
            <vx-input-group class="mb-3">
                Image:
                <input type="file" class="form-control-file" ref="image" v-on:change="handleImage()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                Big Image:
                <input type="file" class="form-control-file" ref="big_image" v-on:change="handlebigImage()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-button color="warning" type="filled" @click="storeSlide">Save</vs-button>
            </vx-input-group>
        </vs-popup>
        <vs-button  @click="popupActive = true;clearData()" >New Slide</vs-button>
        <br>
       
        <br>
        <v-row>
            <v-col v-for="(slide,index) in slides" :key="index"   md="6" lg="6">
            <img :src="slide.image"  width="200">
            <div class="flex">
               <vs-button radius color="danger" type="filled" icon="delete" size="small" @click="deleteSlide(slide)"></vs-button>
          <vs-button class="mx-1" radius color="warning" type="filled" icon="edit" size="small" @click="editSlide(slide)"></vs-button>  
            </div>
           
            </v-col>
        </v-row>
    </div>
</template>
<script>
import vSelect from 'vue-select'
export default {
    components:{vSelect },
    data() {
        return {
            channels:[],
            schedule:[],
            slides:[],
            popupActive:false,
            slide:{
                id:0,
                title:'',
                decription:'',
                channel_id:'',
                program_id:'',
                image:'',
                big_image:''
            }
        }
    },
    created() {
        this.getSlides();
        this.getChannels();
        this.getSchedule();
    },
    methods: {

getChannels(){
   this.axios.get(`${this.$apiUrl}/v2/tv/channels/all`).then(res=>{
    this.channels=res.data
   })
},

getSchedule(){
           this.axios.get(`${this.$apiUrl}/v2/tv/schedule/all`).then(res=>{
               this.schedule=res.data;
           })
},

getSlides(){
   this.axios.get(`${this.$apiUrl}/v2/tv/slides`).then(res=>{
       this.slides=res.data;
   })
},

storeSlide(){
    const data=new FormData();
    data.append('id',this.slide.id)
    data.append('title',this.slide.title)
    data.append('decription',this.slide.decription)
    data.append('image',this.slide.image)
    data.append('big_image',this.slide.big_image)
    data.append('channel_id',this.slide.channel_id.id)
    data.append('program_id',this.slide.program_id.id)
    this.axios.post(`${this.$apiUrl}/v2/tv/slides`,data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res=>{
        res;
        this.popupActive=false;
       this.clearData();
        this.getSlides()
    })
},

deleteSlide(slide){
    if (confirm('Are You Sure?')) {
        this.axios.post(`${this.$apiUrl}/v2/tv/slides/${slide.id}/del`).then(res=>{
        this.getSlides()
    })
    }
   
},

editSlide(prog){
    this.slide=prog;
    this.popupActive=true;
},

clearData(){
    this.slide={
                title:'',
                decription:'',
                channel_id:0,
                program_id:0,
                image:'',
                big_image:''
            }
},

handleImage() {
        this.slide.image = this.$refs.image.files[0];
    },
    handlebigImage() {
        this.slide.big_image = this.$refs.big_image.files[0];
    },

}
}
</script>
